import { generateShortId } from '..';
import { Coordinates } from './Coordinates'
import { Location } from './Location'

interface TimeOrDistance {
  to: number;
  total: number;
}

/* NEW */
// Computed locally
interface PlaceTimestamps {
  arrival: number;
  departure: number;
}

// In the database:
interface PlaceTime {
  to: number;
  total: number;
  break: number;
}
interface PlaceDistance {
  to: number;
  total: number;
}
/* --- */


export interface PlaceTimes extends PlaceTimestamps {
  break: number;
}

interface LivePlaceState {
  times: PlaceTimestamps;
  latest: boolean;
  current: boolean;
  visited: boolean;
  next: boolean;
}

export interface Place extends Location {
  id: string;
  index: number;
  first?: boolean;
  last?: boolean;
  breakTime: number;
  times: PlaceTimes;
  curbCoords: Coordinates;
  duration: TimeOrDistance;
  distance: TimeOrDistance;
  live?: LivePlaceState;
}

export class PlaceModel implements Place {
  id: string;
  address: string;
  name: string;
  coords: Coordinates;
  curbCoords: Coordinates;
  index = 0;
  times = {break: 0, arrival: 0, departure: 0}
  breakTime = -1;
  duration: TimeOrDistance;
  distance: TimeOrDistance;
  constructor(location?: Location) {
    this.id = generateShortId()
    this.address = location ? location.address : ''
    this.name = location ? location.name : 'Stop ' + this.id
    this.coords = location ? { ...location.coords } : { lat: 0, lon: 0 }
    this.curbCoords = { lat: 0, lon: 0 }
    this.duration = { to: 0, total: 0 }
    this.distance = { to: 0, total: 0 }
  }
}